import React from 'react'
import { PageHeader, Descriptions, Divider, Button } from 'antd'
import { LAYOUT_ADMIN_NOTIFICATION_GROUP_EDIT } from '../../navigation'
import { useToggle, useFetch } from '../../../../hooks/admin/notification'
import { Link, useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'
import Notifications from './notifications'

export const Show = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const { mutate: toggle, isLoading: isToggleLoading } = useToggle(id)
  const history = useHistory()

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  return (
    <>
      <div className='site-page-header-ghost-wrapper'>
        <PageHeader
          ghost={false}
          className='site-page-header'
          onBack={onPressBack}
          title={data.entidad?.name}
          subTitle='Notifications'
          extra={[
            <Link key='1' to={LAYOUT_ADMIN_NOTIFICATION_GROUP_EDIT(id)}>
              <Button type='primary' size='small'>
                <i className='fa fa-pencil-square-o' />
                <Divider type='vertical' />
                Update
              </Button>
            </Link>
          ]}
        >
          <Descriptions size='medium' column={2}>
            <Descriptions.Item label='TO/CC'> {data.entidad.cc} </Descriptions.Item>
            <Descriptions.Item label='CCO'> {data.entidad.cco} </Descriptions.Item>
            <Descriptions.Item label='Description'> {data.entidad.description} </Descriptions.Item>
          </Descriptions>
        </PageHeader>
      </div>

      <br />
      <PageHeader ghost={false}>
        <Notifications
          list={data.entidad?.notifications || []}
          onChangeStatus={toggle}
          isSecondaryLoading={isToggleLoading}
        />
      </PageHeader>
    </>
  )
}
export default Show
